import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import { formatCurrency } from 'ggx-service/i18n/format-currency.service'
import { VoucherModal } from 'ggx-src/billing/voucher/voucher-modal.component'

import { StyledLink, Menu } from './order-price-breakdown.component.styles'

const CouponSelection = ({ input, total, discount }) => {
  const [t] = useTranslation()
  const [showVoucherModal, setShowVoucherModal] = useState(false)

  return discount !== undefined ? (
    <StyledLink as="a" noMargin>
      <span>{formatCurrency({ amount: discount })}</span>
      <Menu>
        <Menu.Row noMargin onClick={() => input.onChange([])}>
          {t('remove_coupon')}
        </Menu.Row>
      </Menu>
    </StyledLink>
  ) : (
    <StyledLink as="a" noMargin>
      <span onClick={() => setShowVoucherModal(true)}>{t('add_coupon')}</span>
      {showVoucherModal && (
        <VoucherModal
          orderPrice={total}
          serviceType="delivery"
          onSelectCoupon={coupon => {
            input.onChange([coupon.available[0]])
          }}
          onModalClose={() => setShowVoucherModal(false)}
        />
      )}
    </StyledLink>
  )
}

CouponSelection.propTypes = {
  input: PropTypes.shape({
    value: PropTypes.array,
    onChange: PropTypes.func,
  }),
  total: PropTypes.number,
  discount: PropTypes.number,
}

export { CouponSelection }
